<div class="modal-header">
    <h3 class="modal-title" id="modal-title-id">{{LOCALIZATION.printDocumentArea}}</h3>
    <h5 class="modal-subtitle">
		<span [innerHTML]="product.title | safeHtml"></span>
	</h5>
    <h5 class="modal-subtitle" [hidden]="!product.singlePageMode">
		<span class="truncate">{{LOCALIZATION.page}} {{product.page}}</span>
	</h5>	
	<h5 class="help-block">
		<span>{{LOCALIZATION.cropTooltip}}</span>
	</h5>	
</div>
<div class="modal-body print-area-body">
	<div id="screen-container" [hidden]='captureSelectionHide' class="capture-selection">
		<div #regionContainer class="region-container">
			<img #screenshot id="screenshot"
				 [src]="product.prePrintURL" 
				 (load)="onLoaded($event)" 
				 (error)="onError($event)"/>
			<div #region id="region"></div>
		</div>
	</div>
	<canvas #slice id="slice" [hidden]='printSelectionHide' class="print-selection"></canvas>
</div>
<div class="modal-footer">
	<button class="btn btn-default" type="button" (click)="close()">{{LOCALIZATION.cancel}}</button>
	<button id="crop" [hidden]='loading || captureSelectionHide' class="btn btn-primary capture-selection" (click)="cropArea()">{{LOCALIZATION.cropArea}}</button>
	<button id="reset" [hidden]='loading || printSelectionHide' class="btn btn-primary print-selection" (click)="resetSelection()">{{LOCALIZATION.reset}}</button>
	<button id="print" [hidden]='loading || printSelectionHide' class="btn btn-primary print-selection" (click)="printSlice()">{{LOCALIZATION.print}}</button>
</div>
